import Icon, { IconProps } from "../Icon"
import { ReactComponent as SvgIcon } from "./icon-chevron-down.svg"

export default function IconChevronDown(props: IconProps) {
  return (
    <Icon {...props}>
      <SvgIcon />
    </Icon>
  )
}
